module.exports = __webpack_public_path__ + "img/gdco-login.01912c20.svg";